import { createContext } from "react";
import { ConfigManagement } from '../../models/config/configManagement'

// Valor por defecto
const defaultValue = new ConfigManagement();

// Creación de Context para su posterior configuración propia del cliente para la aplicación
export const ConfigContext = createContext(defaultValue);
